import { render } from "./BrowserFrame.vue?vue&type=template&id=1c58cd24&scoped=true"
import script from "./BrowserFrame.vue?vue&type=script&lang=js"
export * from "./BrowserFrame.vue?vue&type=script&lang=js"

import "./BrowserFrame.vue?vue&type=style&index=0&id=1c58cd24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c58cd24"]])

export default __exports__